import { ElementRef, Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { WindowEventsService } from '@app/core/services/window-events/window-events.service';

@Injectable({ providedIn: 'root' })
export class ListVisibilityService {
  constructor(private windowEventsService: WindowEventsService) {}

  public getObservable$(list: ElementRef, threshold = 1): Observable<number> {
    return this.getExperiencesVisibilityObservable$(list, threshold);
  }

  private getExperiencesVisibilityObservable$(list: ElementRef, threshold: number): Observable<number> {
    if (list?.nativeElement?.children?.length) {
      const indexVisible$ = new BehaviorSubject(0);
      const intersectionObserverOptions = { threshold: threshold };
      for (let index = 0; index < list.nativeElement.children.length; index++) {
        this.windowEventsService.createIntersectionObserver(
          this.createIntersectionObserverCallback(index, indexVisible$),
          list.nativeElement.children[index],
          intersectionObserverOptions,
        );
      }
      // Use observable to call changeActiveMarker, not directly from callback
      // for debounce and distinctUntilChanged functionality
      return indexVisible$.asObservable().pipe(debounceTime(200), distinctUntilChanged());
    }
    return EMPTY;
  }

  private createIntersectionObserverCallback(
    index: number,
    indexVisible$: BehaviorSubject<number>,
  ): IntersectionObserverCallback {
    return entries => {
      const numEntriesIntersecting = entries.filter(entry => entry.isIntersecting).length;
      if (numEntriesIntersecting) {
        indexVisible$.next(index);
      }
    };
  }
}
